import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ChangeDate",
    title: "Смена даты доставки",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.changeDate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        type: "date",
        placeholder: "Укажите новую дату доставки",
        value: _ctx.state.new_date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.new_date) = $event)),
        "is-invalid": _ctx.state_form$.new_date.$error,
        "validation-errors": _ctx.state_form$.new_date.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        placeholder: "Причина переноса",
        loading: _ctx.data_state.statuses.is_loading,
        failed: _ctx.data_state.statuses.is_failed,
        "error-text": "При получении списка статусов произошла ошибка",
        options: _ctx.data_state.statuses.list,
        value: _ctx.state.statusCode,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.statusCode) = $event)),
        onRefresh: _ctx.loadStatuses,
        "select-by": "code",
        searchable: false,
        "is-invalid": _ctx.state_form$.statusCode.$error,
        "validation-errors": _ctx.state_form$.statusCode.$errors,
        class: "mt-3"
      }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}